// extracted by mini-css-extract-plugin
export default {"countpeople":"CountPeople_countpeople__0C96R","countText":"CountPeople_countText__NLSaO"};